// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1MgIw","actions":"GroupTable_actions__v_5r7","deleteModalFooter":"GroupTable_deleteModalFooter__1HnGI"};